export class Pipe {
  private fns: Function[] = [];

  pipe(fn: Function) {
    this.fns.push(fn);
    return this;
  }

  pipeToFunc(fn: Function) {
    return this.pipe(fn).toFunc();
  }

  toFunc() {
    return (...args: any[]) => {
      const fn = this.fns[0];
      if (!fn) {
        return undefined;
      }

      let result = fn(...args);

      this.fns.slice(1).forEach(fn => {
        result = fn(result);
      });

      return result;
    };
  }
}

export function pipe(fn: Function) {
  return (new Pipe()).pipe(fn);
}
